import styled from 'styled-components';
import { MdClose, MdDeleteOutline } from 'react-icons/md';
import { colors, radii } from '@gbs-monorepo-packages/styles';
import { FileIcon } from '../FileIcon';

export const FileDropzoneContainer = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 1rem;
`;

export const DropzoneBox = styled.div`
  width: 100%;
  color: ${colors.gray400};
  text-align: center;
  font-size: 1rem;
  margin-bottom: 1rem;
`;

export const FileIconCustom = styled(FileIcon)`
  width: 32px;
  height: 32px;
  border-radius: ${radii.sm};
`;

export const FileDetails = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-width: 0;
`;

export const FileName = styled.span`
  font-size: 0.95rem;
  font-weight: 500;
  color: ${colors.text};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 450px;
`;

export const FileSize = styled.span`
  font-size: 0.85rem;
  color: ${colors.gray400};
`;

export const FilePreviewContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  background: ${colors.backgroundHover};
  border-radius: ${radii.md};
  padding: 0.5rem 0.5rem;
  margin-bottom: 1rem;
`;

export const FilePreviewInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 80%;
  white-space: nowrap;
  overflow: hidden;

  & > span {
    width: auto;
  }
`;

export const DeleteButton = styled.button`
  background-color: transparent;
  border: none;
`;

export const DeleteIcon = styled(MdDeleteOutline)`
  height: 1.5rem;
  width: 1.5rem;

  &:hover {
    color: ${colors.blue300};
  }
`;

export const CloseIcon = styled(MdClose)`
  height: 1rem;
  width: 1rem;
  transition: transform 0.2s ease;
`;

export const CloseDropzoneButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  background: transparent;
  border: none;
  color: ${colors.gray350};
  font-size: 1.2rem;
  cursor: pointer;
  z-index: 2;
  padding: 0;
  line-height: 1;
  transition: color 0.2s ease;

  &:hover,
  &:focus {
    color: ${colors.red300};
  }

  &:hover ${CloseIcon} {
    transform: scale(1.1);
  }

  &:focus {
    outline-offset: 2px;
  }
`;
